var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9165 12.195L10.4165 13.6383C10.1587 13.7872 9.841 13.7872 9.58317 13.6383L7.08317 12.195C6.82534 12.0461 6.66651 11.771 6.6665 11.4733V8.52665C6.66651 8.22893 6.82534 7.95384 7.08317 7.80498L9.58317 6.36165C9.841 6.21278 10.1587 6.21278 10.4165 6.36165L12.9165 7.80498C13.1743 7.95384 13.3332 8.22893 13.3332 8.52665V11.4733C13.3332 11.771 13.1743 12.0461 12.9165 12.195Z",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1573 14.6338L10.8795 17.6809C10.3352 17.9951 9.66461 17.9951 9.1203 17.6809L3.84252 14.6338C3.2982 14.3195 2.96289 13.7387 2.96289 13.1102V6.88961C2.96289 6.26109 3.2982 5.68031 3.84252 5.36605L9.1203 2.31895C9.66461 2.00469 10.3352 2.00469 10.8795 2.31895L16.1573 5.36605C16.7016 5.68031 17.037 6.26109 17.037 6.88961V13.1102C17.037 13.7387 16.7016 14.3195 16.1573 14.6338V14.6338Z",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2217 8.11011L10.4167 9.72962C10.1588 9.87844 9.84117 9.87844 9.58332 9.72962L6.77832 8.11011",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 13.7499V9.84033",
    stroke: "#525866",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntities);
export default __webpack_public_path__ + "static/media/Entities.25c001bf764b59a6a361c4dd48aa42ef.svg";
export { ForwardRef as ReactComponent };